import React from 'react';
import styles from './styles.module.scss';

import LinkWrap from '../../Wraps/LinkWrap';
import ImagePlaceholder from '../../Placeholder';

import Config, { spanish } from '../../../config/config';

import placeholderMobile from '../../../assets/placeholder/400.jpg';
import placeholderDesktop from '../../../assets/placeholder/560.jpg';

const Item = ({
  seo,
  imageMobile,
  imageDesktop,
  product,
  category,
  url,
  isExternal,
}) => {
  let linkTo = url;
  let linkState = {};
  if (product !== null) {
    linkTo = `/product/${product?.SLUG}`;
    linkState = { sku: product?.SKU };
  } else if (category !== null) {
    linkTo = `/category/${category?.SLUG}`;
    linkState = {
      categoryId: category?.categoryID,
      categoryName: spanish ? category?.NameSpanish : category?.NameEnglish,
    };
  }
  return (
    linkTo !== null && (
      <LinkWrap
        to={linkTo}
        className={styles.item}
        state={linkState}
        isExternal={isExternal}
      >
        {seo && imageMobile && imageDesktop ? (
          <picture>
            <source
              srcSet={`${Config.cdn.cdn_path}${imageDesktop}`}
              media="(min-width: 1025px)"
            />
            <img src={`${Config.cdn.cdn_path}${imageMobile}`} alt={seo} />
          </picture>
        ) : (
          <ImagePlaceholder
            mobile={placeholderMobile}
            desktop={placeholderDesktop}
          />
        )}
      </LinkWrap>
    )
  );
};

const TopBanners = ({ data }) => {
  const topLeft = data?.find((item) => item?.Position === 'TopLeft');
  const topRight = data?.find((item) => item?.Position === 'TopRight');
  return (
    <div className={styles.container}>
      <Item
        seo={topLeft?.SEO}
        imageMobile={
          spanish ? topLeft?.imageMobile?.url : topLeft?.imageMobileEnglish?.url
        }
        imageDesktop={
          spanish
            ? topLeft?.imageDesktop?.url
            : topLeft?.imageDesktopEnglish?.url
        }
        product={topLeft?.product}
        category={topLeft?.category}
        url={topLeft?.LinkTo}
        isExternal={topLeft?.isExternal}
      />
      <Item
        seo={topRight?.SEO}
        imageMobile={
          spanish
            ? topRight?.imageMobile?.url
            : topRight?.imageMobileEnglish?.url
        }
        imageDesktop={
          spanish
            ? topRight?.imageDesktop?.url
            : topRight?.imageDesktopEnglish?.url
        }
        product={topRight?.product}
        category={topRight?.category}
        url={topRight?.LinkTo}
        isExternal={topRight?.isExternal}
      />
    </div>
  );
};

export default TopBanners;
